module.exports = __webpack_public_path__ + "static/media/shop-purple-cap.3013559f.png";